import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectTokensPacks } from '../../../store/products/products.selects';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { TokensPack } from '../../../class/tokensPack.class';
import { ButtonComponent } from '../../boutons/button/button.component';
import { LucideAngularModule } from 'lucide-angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tokens-packs-modal',
  imports: [AsyncPipe, ButtonComponent, LucideAngularModule, TranslateModule],
  templateUrl: './tokens-packs-modal.component.html',
  styleUrls: ['../modal-styles.scss', './tokens-packs-modal.component.scss'],
})
export class TokensPacksModalComponent {
  @Output() tokensPackClick: EventEmitter<TokensPack> =
    new EventEmitter<TokensPack>();
  private store: Store = inject(Store);
  tokensPacks$: Observable<TokensPack[]> = this.store.select(selectTokensPacks);
}
